import React, { useEffect, useState } from "react";
import axios from "axios";
import "./TeacherAssignSubjective.css";

const TeacherAssignSubjective = () => {

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const token = localStorage.getItem("token");

  const [teachers, setTeachers] = useState([]);
  const [classes, setClasses] = useState([]);
  const [competitions, setCompetitions] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [assignments, setAssignments] = useState([]);

  const [selectedReferenceType, setSelectedReferenceType] = useState("class");
  const [selectedReference, setSelectedReference] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedTeacher, setSelectedTeacher] = useState("");

  // ================= FETCH TEACHERS =================
  const fetchTeachers = async () => {
    const res = await axios.get(
      `${API_BASE_URL}/admin/searchallteacher`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    setTeachers(res.data.teachers || []);
  };

  // ================= FETCH CLASSES + COMPETITIONS =================
  const fetchReferences = async () => {
    const res = await axios.get(
      `${API_BASE_URL}/subjective-exam?category=Subjective_Exam`
    );

    setClasses(res.data.data.classes || []);
    setCompetitions(res.data.data.competitions || []);
  };

  // ================= FETCH SUBJECTS =================
  const fetchSubjects = async (referenceId) => {
    const res = await axios.get(
      `${API_BASE_URL}/subjects?reference=${referenceId}&category=subjective_exam`
    );
    setSubjects(res.data.data || []);
  };

  // ================= FETCH ASSIGNMENTS =================
  const fetchAssignments = async () => {
    const res = await axios.get(
      `${API_BASE_URL}/admin/teacher-assign`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    setAssignments(res.data.data || []);
  };

  useEffect(() => {
    fetchTeachers();
    fetchReferences();
    fetchAssignments();
  }, []);

  // ================= ASSIGN =================
  const handleAssign = async () => {

    if (!selectedTeacher || !selectedReference || !selectedSubject) {
      alert("All fields are required");
      return;
    }

    await axios.post(
      `${API_BASE_URL}/admin/teacher-assign`,
      {
        teacherId: selectedTeacher,
        subjectId: selectedSubject,
        referenceId: selectedReference,
        referenceType: selectedReferenceType
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    fetchAssignments();
    alert("Teacher Assigned Successfully");

    setSelectedSubject("");
    setSelectedTeacher("");
  };

  // ================= UPDATE =================
  const handleUpdate = async (assignmentId, teacherId) => {
    await axios.put(
      `${API_BASE_URL}/admin/teacher-assign/${assignmentId}`,
      { teacherId },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    fetchAssignments();
  };

  // ================= DELETE =================
  const handleDelete = async (assignmentId) => {
    await axios.delete(
      `${API_BASE_URL}/admin/teacher-assign/${assignmentId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    fetchAssignments();
  };

  return (
    <div className="teacher-container">

      <h2 className="title">Subjective Teacher Assignment</h2>

      <div className="card">

        <div className="form-group">

          <label>Reference Type</label>
          <select
            value={selectedReferenceType}
            onChange={(e) => {
              setSelectedReferenceType(e.target.value);
              setSelectedReference("");
              setSubjects([]);
            }}
          >
            <option value="class">Class</option>
            <option value="competition">Competition</option>
          </select>

          <label>
            {selectedReferenceType === "class"
              ? "Select Class"
              : "Select Competition"}
          </label>

          <select
            value={selectedReference}
            onChange={(e) => {
              setSelectedReference(e.target.value);
              fetchSubjects(e.target.value);
            }}
          >
            <option value="">Select</option>
            {(selectedReferenceType === "class"
              ? classes
              : competitions
            ).map((item) => (
              <option key={item._id} value={item._id}>
                {item.className || item.examCategory}
              </option>
            ))}
          </select>

          <label>Select Subject</label>
          <select
            value={selectedSubject}
            onChange={(e) => setSelectedSubject(e.target.value)}
          >
            <option value="">Select</option>
            {subjects.map((sub) => (
              <option key={sub._id} value={sub._id}>
                {sub.subjectName}
              </option>
            ))}
          </select>

          <label>Select Teacher</label>
          <select
            value={selectedTeacher}
            onChange={(e) => setSelectedTeacher(e.target.value)}
          >
            <option value="">Select</option>
            {teachers.map((teacher) => (
              <option key={teacher._id} value={teacher._id}>
                {teacher.basicInfo?.fullName}
              </option>
            ))}
          </select>

          <button className="assign-btn" onClick={handleAssign}>
            Assign Teacher
          </button>
        </div>
      </div>

      <div className="table-card">
        <h3>Assigned Teachers</h3>

        <table>
          <thead>
            <tr>
              <th>Teacher</th>
              <th>Subject</th>
              <th>Reference</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {assignments.map((item) => (
              <tr key={item._id}>
                <td>{item.teacherId?.basicInfo?.fullName}</td>
                <td>{item.subjectId?.subjectName}</td>
                <td>{item.referenceType}</td>
                <td>
                  <select
                    onChange={(e) =>
                      handleUpdate(item._id, e.target.value)
                    }
                  >
                    <option>Change</option>
                    {teachers.map((teacher) => (
                      <option key={teacher._id} value={teacher._id}>
                        {teacher.basicInfo?.fullName}
                      </option>
                    ))}
                  </select>

                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(item._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default TeacherAssignSubjective;